import { HttpUrlEncodingCodec } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpTestService } from "app/services/http.service";

@Component({
  selector: "app-prepaid-payment-success",
  templateUrl: "./prepaid-payment-success.component.html",
  styleUrls: ["./prepaid-payment-success.component.css"],
})
export class PrepaidPaymentSuccessComponent implements OnInit {
  public message: any;
  decodeMsg: any;
  array: any;

  consumerId: any;
  transactionNo: any;
  billdeskTransaction: any;
  desc: any;
  transactionDateTime: any;
  paymentGateway: any;
  meterNo: any;
  amount: any;
  remarkMessage: any;
  remark: any;

  successMsgSection: boolean = true;
  transSection: boolean = false;
  public serviceOn: boolean = false;

  transactionInfo: any;
  vendorId: any;
  utrnCode: any;
  uuid: any;
  errorMsg: any = '';
  errorShow: boolean = false;
  statusMessage: any = 'Please wait while we are sending the token to meter...';

  constructor(
    private route: ActivatedRoute,
    public httpService: HttpTestService
  ) {
    this.route.queryParams.subscribe((params) => {
      // console.log("QWERTY******");
      this.message = params['msg'];

      this.decodeMsg = window.atob(this.message);
    
      this.array = this.decodeMsg.split("&");

      console.log("splitted message ", this.array)

      this.consumerId = this.array[0].split("=")[1];
      this.transactionNo = this.array[1].split("=")[1];
      this.billdeskTransaction = this.array[2].split("=")[1];
      this.desc = this.array[3].split("=")[1];
      this.transactionDateTime  = this.array[4].split("=")[1];
      this.paymentGateway = this.array[5].split("=")[1];
      this.meterNo = this.array[6].split("=")[1];
      this.amount = this.array[7].split("=")[1];
      this.remarkMessage = this.array[8].split("=")[1];
      this.remark = this.array[9].split("=")[1];
      this.vendorId = this.array[10].split("=")[1];
      this.utrnCode = this.array[11].split("=")[1];

      // if(this.array[10].split("=")[1] == 4){
      //   this.uuid = this.array[12].split("=")[1];
      // }
      // 

      // console.log("vendorId ", this.vendorId)
      // let url =
      //   "Y29uc2lkPTcxMDM1MDEmdHhubz0yMDIzMTEwNjA1MzgxOF83MCZiZHR4bm89WkhENTE1MTU5OTIxNjkmZGVzYz1QR1MxMDAwMS1TdWNjZXNzJnR4bmR0PTA2LTExLTIwMjMgMTc6Mzg6NDMmcGF5Z3R5PUJJTExERVNLIFBBWU1FTlQmbWV0bm89NzE3NzAyOSZhbXQ9MS4wMCZybXNnPVNVQ0NFU1MmcmVta3M9UGF5bWVudCBTdWNjZXNzZnVsISZ2ZWRvcmlkPTEmdXRybj0=";
      // this.decodeMsg = atob(url);
      // this.array = this.decodeMsg.split("&");

      // console.log(this.decodeMsg);
      // console.log(this.array);

      // this.consumerId = this.array[0].split("=")[1];
      // this.transactionNo = this.array[1].split("=")[1];
      // this.billdeskTransaction = this.array[2].split("=")[1];
      // this.desc = this.array[3].split("=")[1];
      // this.transactionDateTime = this.array[4].split("=")[1];
      // this.paymentGateway = this.array[5].split("=")[1];
      // this.meterNo = this.array[6].split("=")[1];
      // this.amount = this.array[7].split("=")[1];
      // this.remarkMessage = this.array[8].split("=")[1];
      // this.remark = this.array[9].split("=")[1];
      // this.vendorId = this.array[10].split("=")[1];
      // this.utrnCode = this.array[11].split("=")[1];
      // this.uuid = this.array[12].split("=")[1];

      

      // setTimeout(()=>{
      //   if(this.array[10].split("=")[1] == 4){
      //     this.getMeterRechargeStatus();
      //   }
       
      // }, 30000);


      
    });
  }

  getMeterRechargeStatus(){
    this.serviceOn = true;
    this.httpService.getProcessStatusByOldCapital(this.uuid).subscribe(
      response => {
        // console.log("response ",response)
        this.statusMessage = response.message;
        this.serviceOn = false;
      }, error => {
      
      });
  }

  ngOnInit() {}

  // transactionDetails() {
  //   this.serviceOn = true;
  //   this.httpService
  //     .prepaidTransactionStatus(this.billdeskTransaction, this.meterNo)
  //     .subscribe(
  //       (response) => {
  //         console.log("response ", response);
  //         if (response["status"] == 1) {
  //           if (response["vendorData"].flag == "T") {
  //             this.successMsgSection = false;
  //             this.transSection = true;
  //             this.serviceOn = false;

  //             this.transactionInfo = response["vendorData"].data[0];
  //           }
  //         }
  //       },
  //       (error) => {}
  //     );
  // }

  transactionDetails() {
    this.serviceOn = true;
    this.httpService
      .prepaidTransactionStatus(this.billdeskTransaction, this.meterNo)
      .subscribe(
        (response) => {
          console.log("response ", response);
          if (response["status"] == 1) {
            if (response["vendorId"] == 2) {
              this.successMsgSection = false;
              this.transSection = false;
              this.serviceOn = false;
              this.errorMsg = response["message"];
              this.errorShow = true;
              // this.transactionInfo = response["vendorData"].data[0];
            } else {
              if (response["vendorData"].flag == "T") {
                this.successMsgSection = false;
                this.errorShow = false;
                this.transSection = true;
                this.serviceOn = false;
                this.transactionInfo = response["vendorData"].data[0];
              }
            }
          }
          else{
            // this.serviceOn = false;
            // this.errorMsg = response["message"];
            this.successMsgSection = false;
            this.transSection = false;
            this.serviceOn = false;
            this.errorMsg = response["message"];
            this.errorShow = true;
          }
        },
        (error) => {}
      );
  }

  back(){
    this.transSection = false;
    this.errorShow = false;
    this.successMsgSection = true;
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-payment-success/prepaid-payment-success.component.ts